/**
 * Created by fers on 05.02.16.
 */

import PureRenderMixin from 'react-addons-pure-render-mixin';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import LoadingButton from './LoadingButton.react';
import * as BrowserPermission from "../BrowserPermission";

const messages = defineMessages({
    addButton: {id: 'action.create', 'defaultMessage': 'Create {entity}'}
});

interface AddButtonProps {
    className?: any;
    icon?: string;
    intl: IntlShape;
    metadata: object;
    organisationId?: string;
    parent?: object;
    target?: string;
    title?: string;
    urlMapping: object;
}

class AddButton extends React.Component<AddButtonProps> {
    static propTypes = {
		className: PropTypes.any,
		icon: PropTypes.string,
        intl: PropTypes.object.isRequired,
        metadata: PropTypes.object.isRequired,
        organisationId: PropTypes.string,
        parent: PropTypes.object,
        target: PropTypes.string,
		title: PropTypes.string,
        urlMapping: PropTypes.object.isRequired,
    };

	static defaultProps = {
		icon: 'fa-plus',
	};

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    static contextTypes = {
        router: PropTypes.object
    };

    onClick(event) {
		if (!event.metaKey && !event.ctrlKey) {
			setTimeout(() => {
				this.context.router.push(this.getPath());
			});

			return false;
		}
    }

	getPath() {
		let {urlMapping, metadata, parent} = this.props;

        return urlMapping.getUrl(metadata, "create", parent);
	}

    render() {
        let { metadata } = this.props;

        if (metadata.canUserCreate() && metadata.canCreate(BrowserPermission.getPermissionObject(), null, this.props.organisationId)) {
			let title =  this.props.title || this.props.intl.formatMessage(messages.addButton, {'entity': this.props.metadata.singularName()});

            return (
                <div className="add-button-sizer">
                    <div className={"add-button bottom-corner " + (this.props.className ? this.props.className : "")} style={{position: "fixed", bottom: "20px", right: "64px", "z-index": "10"}}>
                        {this.props.target ?
                            <a className="btn btn-primary btn-circle btn-lg" href={this.props.urlMapping.getUrl(this.props.metadata, "create", this.props.parent)} target={this.props.target} title={title}>
                                <span className={"fa " + this.props.icon}></span>
                            </a>
                            :
                            <LoadingButton className="btn btn-primary btn-circle btn-lg" href={this.getPath()} onClick={(e) => {return this.onClick(e);}} title={title} type="link">
                                <span className={"fa "  + this.props.icon}></span>
                            </LoadingButton>
                        }
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default injectIntl(AddButton);

class AddButtonAboveClass extends AddButton {
    static propsTypes = {
        list: PropTypes.array.isRequired,
    };

    render() {
        if (this.props.list && this.props.list.length >= 10) {
            return super.render();
        }

        return null;
    }
}

export let AddButtonAbove = injectIntl(AddButtonAboveClass);
